import Image from '@app/components/Image'
import { IDevelopmentSite } from '@app/models/DevelopmentSite'
import { ImageSize } from '@app/models/enums'
import { siteRoutingActionCreators } from '@app/routes/Development/Clients/Sites/View/modules/developmentSiteView'
import * as React from 'react'

export interface IDevelopmentSiteResultItemProps {
  item: IDevelopmentSite
}

type DevelopmentSiteResultItemProps = IDevelopmentSiteResultItemProps &
  typeof siteRoutingActionCreators

export class DevelopmentSiteResultItem extends React.PureComponent<
  DevelopmentSiteResultItemProps
> {
  public render() {
    return (
      <a onClick={this.goToSite} className='result-item'>
        <div className='align-self-center'>
          <Image
            defaultImageUrl='/images/default-property_h_50_w_50.png'
            height={35}
            image={this.props.item.coverPhoto}
            size={ImageSize.h50w50}
            width={35}
          />
        </div>
        <div className='flex-grow-1 align-self-center font-weight-bold'>
          {this.props.item.title}
        </div>
      </a>
    )
  }

  private goToSite = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    this.props.getSiteRouting(this.props.item.id)
  }
}
